import { render, staticRenderFns } from "./orderRedeem.vue?vue&type=template&id=f278d40e&scoped=true&"
import script from "./orderRedeem.vue?vue&type=script&lang=js&"
export * from "./orderRedeem.vue?vue&type=script&lang=js&"
import style0 from "./orderRedeem.vue?vue&type=style&index=0&id=f278d40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f278d40e",
  null
  
)

export default component.exports